import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { selectTagList, selectUserFormData } from "app/redux/selector";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import MenuItems from "./MenuItems";
import ticketTagsSaga from "./redux/saga";
import { selectTagDeleteModal } from "./redux/selector";
import { ticketTagsReducer, ticketTagsSlice } from "./redux/slice";
import TagRemoveWrapper from "./TagRemoveWrapper";
import { ITagsProps } from "./types";

const Index: React.FC<ITagsProps> = ({
  onTagsChange,
  selectedTags,
  trigger,
  align = "center",
  className,
  dropdownContainerClassName,
  isHeader,
  searchPlaceholder,
  onOpen,
  onClose,
  isFullWidth,
  open,
  setOpen,
}) => {
  useInjectReducer({
    key: ticketTagsSlice,
    reducer: ticketTagsReducer,
  });

  useInjectSaga({ key: ticketTagsSlice, saga: ticketTagsSaga });

  const { selectedProjectId } = useSelector(selectUserFormData);

  const tagList = useSelector(selectTagList);
  const shownModal = useSelector(selectTagDeleteModal);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const containerRef = useRef<HTMLDivElement>(null);
  const [dropdownWidth, setDropdownWidth] = useState(0);
  useEffect(() => {
    if (containerRef.current) {
      setDropdownWidth(containerRef.current.offsetWidth);
    }
  }, []);

  useEffect(() => {
    if (shownModal && open) {
      setOpen?.(false);
    }
  }, [shownModal, open, setOpen]);

  const handleOpenChange = (isOpen: boolean) => {
    setOpen?.(isOpen);
    if (isOpen) {
      onOpen?.();
    } else {
      onClose?.();
    }
  };

  const handleDeleteModalClose = () => {
    setShowDeleteModal(false);
  };

  return (
    <>
      <div className="relative w-full ">
        <DropdownMenu.Root
          open={open && !shownModal}
          onOpenChange={handleOpenChange}
        >
          <DropdownMenu.Trigger asChild>{trigger}</DropdownMenu.Trigger>
          <DropdownMenu.Portal>
            <MenuItems
              options={tagList}
              onChange={(values) => {
                onTagsChange(values);
              }}
              dropdownWidth={dropdownWidth}
              selectedIds={selectedTags as string[]}
              align={align}
              headingText={isHeader as string}
              isFullWidth={isFullWidth}
              searchPlaceholder={searchPlaceholder}
              className={className}
              menuContentClassName={dropdownContainerClassName}
              projectId={selectedProjectId}
              onDeleteRequest={() => setShowDeleteModal(true)}
            />
          </DropdownMenu.Portal>
        </DropdownMenu.Root>
      </div>
      {showDeleteModal && (
        <TagRemoveWrapper onClose={handleDeleteModalClose} />
      )}
    </>
  );
};

export default Index;
